// extracted by mini-css-extract-plugin
export default {"WeatherForecastCard":"WeatherForecastCard_WeatherForecastCard__WQmnF","WeatherForecastCard__temperature":"WeatherForecastCard_WeatherForecastCard__temperature__Dbm6Q"};